import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseAdvancePublicCompanyLeadContactProps {
  contactId?: string
  onSuccess: () => void
  onError: () => void
}

export const useAdvancePublicCompanyLeadContact = ({
  contactId,
  onSuccess,
  onError,
}: UseAdvancePublicCompanyLeadContactProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['advancePublicCompanyLeadContact'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/contacts/${contactId}/advance`)
    },
    onSuccess,
    onError,
  })
}
